<template>
    <div>
        <button class="d-none" @click="openSending()" id="openSidebar">open</button>

        <div id="interventionSidebar" class="ix-sidebar ix-sidebar-large">
            <div class="ix-sidebar-header">
                <h5 class="modal-title"><i class="far fa-mail-bulk"></i> Détail de l'envoi</h5>
                <button class="ix-sidebar-btn-close trigger-close-sidebar">
                    <i class="fal fa-times"></i>
                </button>
            </div>

            <div class="ix-sidebar-content">
                <div class="ix-comments-loader" v-if="loadingShow">
                    <i class="far fa-circle-notch fa-spin"></i> Récupération de l'envoie
                </div>

                <div v-if="!loadingShow && sending">

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Date de création</h3>
                        {{ sending.created_at | formatDate() }}
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Emetteur</h3>
                        <span class="ix-avatar sm">
                            <img :src="sending.user.avatar_path" v-if="sending.user.avatar_path">
                            <span v-if="!sending.user.avatar_path">{{ sending.user.initial }}</span>
                        </span>
                        <span class="ix-planning-sidebar-users-content-name">
                            {{ sending.user.fullname }}
                        </span>
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Destinataire</h3>
                        {{ sending.recipient }}
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Objet</h3>
                        <a v-if="sending.sendable_type === 'App\\Models\\Quote'"
                            :href="this.quotes + '/' + sending.sendable_id">Devis</a>
                        <a v-if="sending.sendable_type === 'App\\Models\\Order'"
                            :href="this.orders + '/' + sending.sendable_id">Commande
                            client</a>
                        <a v-if="sending.sendable_type === 'App\\Models\\Invoice'"
                            :href="this.invoices + '/' + sending.sendable_id">Facture
                            client</a>
                        <a v-if="sending.sendable_type === 'App\\Models\\Expense'"
                            :href="this.expenses + '/' + sending.sendable_id">Commande
                            fournisseur</a>
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Type</h3>
                        <span v-if="sending.type === 1">Envoi automatisé</span>
                        <span v-if="sending.type === 2">Courier suivi (La Poste)</span>
                        <span v-if="sending.type === 3">Autre | {{ sending.method }}</span>
                    </div>

                    <div v-if="sending.tracking_number" class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Numéro de suivi</h3>
                        <span>{{ sending.tracking_number }}</span>
                        <small class="form-text text-muted">Pour obtenir plus d'informations, accédez directement a
                            <a href="https://www.laposte.fr/outils/suivre-vos-envois" target="_blank">l'outil de
                                suivi La Poste</a></small>
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Etat</h3>
                        {{ sending.state_label }} <span class="ix-state-badge" :class="sending.state_color"></span>
                    </div>

                    <div v-if="sending.created_at" class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Date d'envoi</h3>
                        {{ sending.created_at | formatDate() }}
                    </div>

                    <div v-if="sending.received_at" class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Date de réception</h3>
                        {{ sending.received_at | formatDate() }}
                    </div>

                    <div v-if="sending.opened_at" class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Date d'ouverture</h3>
                        {{ sending.opened_at | formatDate() }}
                    </div>

                    <div v-if="sending.is_cgv_attached === 1" class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Conditions générales de vente</h3>
                        Oui
                    </div>

                    <div v-if="sending.subject || sending.message" class="ix-bloc-simple-line">
                        <h3 v-if="sending.subject" class="ix-bloc-simple-line-title">Sujet</h3>
                        <span v-if="sending.subject" class="mb-4">{{ sending.subject }}</span>
                        <h3 v-if="sending.message" class="ix-bloc-simple-line-title mt-2">Message</h3>
                        <span v-if="sending.message">
                            <p v-for="(line, index) in formattedRemarks" :key="index">{{ line }}</p>
                        </span>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";

export default {
    name: "SendingModalComponent",
    props: ['quotes', 'orders', 'invoices', 'expenses'],
    data() {
        return {
            loading: true,
            loadingShow: false,
            sending: null,
            url: null,
        }
    },
    methods: {
        openSending: function () {
            this.loadingShow = true;
            this.sending = null;

            var openSidebarButton = document.getElementById("openSidebar");
            var sendingData = openSidebarButton.getAttribute("data-sending");

            this.loadingShow = false;
            this.sending = JSON.parse(sendingData);

            if (this.sending) {
                $("#interventionSidebar").addClass("open");
            }
        },
        closePlanningSidebar: function () {
            this.selectedInspection = null
            this.loadingShow = false
            $('#interventionSidebar').removeClass("open");
        },

    },
    computed: {
        formattedRemarks() {
            return this.sending.message.split('\n');
        }
    }
}
</script>

<style>
.custom-tooltip {
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
}

.ix-planning-item:hover .custom-tooltip {
    visibility: visible;
    opacity: 1;
}

.ix-planning-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.ix-planning-table thead tr th {
    position: sticky;
    top: 0;
    z-index: 1;
}

.ix-planning-cell-week span {
    font-size: 12px;
    font-weight: 500;
    padding: 5px 10px;
    background: var(--ix-background-secondary);
    color: var(--ix-text-secondary);
    display: inline-block;
    border-radius: 5px;
}

.ix-planning-table th,
.ix-planning-table td {
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    border-bottom: 1px solid var(--ix-border-secondary);
    border-right: 1px solid var(--ix-border-secondary);
}

.ix-planning-table tbody tr td:first-child {
    width: 250px;
    min-width: 250px;
    max-width: 250px;
    padding: 5px 10px;
    background: var(--ix-background-secondary);
    color: var(--ix-text-primary);
    font-weight: 500;
}

.ix-planning-cell-day {
    text-align: center;
    text-transform: uppercase;
}

.ix-planning-table thead tr:nth-child(3) th {
    top: 40px;
}

.ix-planning-item {
    position: relative;
    width: 100%;
    height: 25px;
    display: block;
    text-align: center;
    background: #7e004a;
    border-radius: 5px;
    cursor: pointer;
    color: white;
}

.intervention-sidebar-logo {
    width: 100px;
    height: 100px;
    margin: auto;
    border-radius: 10px;
    padding: auto;
    font-size: 30px;
    background: #7e004a;
    text-align: center;
    color: white;
    padding: 25px;
}

.ix-planning-sidebar-date {
    display: block;
    width: 100%;
    text-align: center;
    padding: 5px;
    font-weight: bold;
    font-size: 16px;
}
</style>